module.exports = __webpack_public_path__ + "img/invShoreByBatFlow.eb564397.gif";